var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20.956 4.456l-1.413-1.413-7.544 7.541-7.544-7.541-1.413 1.413L10.583 12l-7.541 7.544 1.413 1.413 7.544-7.541 7.544 7.541 1.413-1.413L13.415 12z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }